import { useParams } from 'react-router';
import { observer } from 'mobx-react-lite';

import { Phase } from './phase-content';
import { useCurrentProject } from '../../hooks/use-current-project';

import styles from './HorizontalMenu.module.scss';
export const HorizontalMenu = observer(() => {
  const { stepId } = useParams() as { spaceId: string; stepId: string };
  const project = useCurrentProject()!;

  return (
    <div className={styles['menu']}>
      <div className={styles['phases']}>
        {project.stages
          ?.slice()
          .sort((a, b) => a.order - b.order)
          .map((stage: any) => (
            <Phase key={stage._id} stage={stage} projectId={project._id} currentStepId={stepId} />
          ))}
      </div>
    </div>
  );
});
